import React from "react";
interface IInputText {
    placeholder?: string;
    name?: string;
    value?: string;
    displayError?: boolean;
    required?: boolean;
    className?: string;
    disabled?: boolean;
    onChange: (value: string) => void;
    onPressEnterKey: () => void;
    autoFocus?: boolean;
}

export class InputText extends React.Component<React.PropsWithChildren<IInputText>> {
    public render (): JSX.Element {
        return (
            <input
                className={
                    "inputComponent__input inputComponent__input--text" +
                    (this.props.displayError ? " inputComponent__input--error " : " ") +
                    this.props.className
                }
                type="text"
                placeholder={this.props.placeholder}
                value={this.props.value}
                required={this.props.required}
                name={this.props.name}
                id={this.props.name}
                disabled={this.props.disabled}
                onChange={(e) => this.props.onChange(e.currentTarget.value)}
                onKeyDown={(e) => e.keyCode === 13 && this.props.onPressEnterKey()}
                autoFocus={this.props.autoFocus}
            />
        );
    }
}

export default InputText;
